<template>
  <drag
    ref="wrapper"
    :transfer-data="{ ...piece, index }"
    class="app-piece"
    @dragstart="handleDragstart"
    @dragend="handleDragend"
  >
    <div
      v-for="(cell, idx) in preparedCells"
      :key="idx"
      :style="cell.style"
      class="app-piece__cell"
    />
  </drag>
</template>

<script>
import * as boardConstants from "@/helpers/board-constants.js";
import { PIECES } from "@/helpers/pieces.js";

export default {
  name: "Piece",
  props: {
    piece: { type: Object, required: true },
    index: { type: Number, required: true },
    centered: { type: Boolean, default: false },
  },
  computed: {
    pieceRef () {
      return PIECES[this.piece.ref];
    },
    cells () {
      return (this.pieceRef) ? this.pieceRef.cells : null;
    },
    offset () {
      if (!this.cells) { return { x: 0, y: 0 }; }
      if (!this.centered) { return { x: 0, y: 0 }; }
      const w = Math.max(...this.cells.map((c) => c.x));
      const h = Math.max(...this.cells.map((c) => c.y));
      return { x: w / 2.0, y: h / 2.0 };
    },
    preparedCells () {
      let style, x, y;
      return this.cells.map((c) => {
        x = (boardConstants.CELL_SIZE + boardConstants.CELL_MARGIN) * (c.x - this.offset.x);
        y = (boardConstants.CELL_SIZE + boardConstants.CELL_MARGIN) * (c.y - this.offset.y);
        style = {
          left: `${x}px`,
          top: `${y}px`,
          backgroundColor: this.pieceRef.color,
        };
        return { ...c, style };
      });
    },
  },
  methods: {
    handleDragstart (data, evt) {
      const { offsetX, offsetY } = evt;
      const x = Math.floor(offsetX / boardConstants.CELL_SIZE + this.offset.x);
      const y = Math.floor(offsetY / boardConstants.CELL_SIZE + this.offset.y);
      data.offset = { x, y };
      this.$store.dispatch("room/setPhantom", this.piece.ref);
    },
    handleDragend () {
      this.$store.dispatch("room/setPhantom", null);
    },
  },
}
</script>

<style lang="scss" scoped>
.app-piece {
  position: relative;
  transform: translate(0,0);
}

.app-piece__cell {
  position: absolute;
  width: 30px;
  height: 30px;
}
</style>
